module.exports = __webpack_public_path__ + "img/097_L.6e260936.png";